
import { Module } from "@/models/module";
import {ModuleService} from "@/services/module-service";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { setTitle, resetTitle } from "@/utils/title";

export default Vue.extend({
	data() {
		return {
			columns: [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Name",
					property: "name",
					width: "200px"
				},
				{
					name: "Price",
					property: "price",
					width: "80px",
					right: true,
					print(val:number):string{
						return `&euro;${val.toFixed(2)}`;
					}
				},
				{
					name: "Pernmanent Price",
					property: "permanentPrice",
					width: "120px",
					right: true,
					print(val:number):string{
						return `&euro;${val.toFixed(2)}`;
					}
				}
			] as IDataTableColumn[],
			selected: [] as Module[],
			ModuleService,
			modules: [...ModuleService.modules]
		};
	},
	computed: {
		canEdit():boolean {
			return this.selected.length == 1;
		},
		editUrl():string {
			if (!this.canEdit) return "#";
			return this.createEditUrl(this.selected[0].id);
		},
		canDelete():boolean {
			return this.selected.length > 0;
		}
	},
	watch: {
		"ModuleService.modules": {
			immediate: true,
			handler(){
				this.modules = [...ModuleService.modules];
			}
		},
	},
	methods: {
		async deleteModules():Promise<void> {
			let confirm = await this.$wf.confirm("Are you sure you want to delete these modules?", "yes", "no");
			if (confirm) {
				for (let module of this.selected) {
					await ModuleService.deleteModule(module);
				}
				ModuleService.getModules();
			}
		},
		onOrder(data:{order:string, ascending:boolean}){
			this.modules.sort((m1,m2):number=>{
				let val1 = (m1 as any)[data.order];
				let val2 = (m2 as any)[data.order];

				if (data.ascending){
					if (val1 > val2){
						return 1;
					}
					return -1;
				}
				if (val1 < val2){
					return 1;
				}
				return -1;
			});
		},
		createEditUrl(id:number):string{
			return  `/modules/${id}/edit`;
		},
		edit(item:Module){
			return this.$router.push(this.createEditUrl(item.id));
		}
	},
	created(){
		setTitle("Modules");
	},
	destroyed(){
		resetTitle();
	}
});
